import { Button, ButtonProps } from '@mantine/core';
import React from 'react';

interface RightAlignedActionButtonProps extends ButtonProps {
  onClick: () => void;
  label: string;
  className?: string;
  style?: React.CSSProperties;
}

const RightAlignedActionButton: React.FC<RightAlignedActionButtonProps> = ({
  onClick,
  label,
  style,
  className,
  ...rest
}) => {
  return (
    <Button onClick={onClick} style={{ marginLeft: 'auto', ...style }} className={className} {...rest}>
      {label}
    </Button>
  );
};

export default RightAlignedActionButton;
